import { Box, Text } from "@mantine/core";
import { isDemoOnly } from "../demo";

export default function DemoBanner() {
  if (!isDemoOnly) return null;

  return (
    <Box
      role="banner"
      sx={{
        width: "100%",
        backgroundColor: "#f59e0b",
        textAlign: "center",
        padding: "8px 16px",
      }}
    >
      <Text size="sm" fw={600} c="#451a03">
        This is a demonstration site for preview purposes only.
      </Text>
    </Box>
  );
}
